import { render } from "./roles_management.html?vue&type=template&id=6c5d6320&external"
import script from "./roles_management.js?vue&type=script&lang=js&external"
export * from "./roles_management.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__